<template>
    <div class="image-block">



        <div v-if="!block.src" :class="['image-placeholder', { 'uploading': uploading }]" @click="triggerFileInput">
            <v-progress-circular v-if="uploading" indeterminate color="primary" size="48"></v-progress-circular>
            <v-icon v-else size="48" color="grey">mdi-image-plus</v-icon>
            <p v-if="!uploading">Cliquez pour ajouter une image</p>
            <p v-else>Upload en cours...</p>
            <input ref="fileInput" type="file" accept="image/*" @change="onFileSelected" style="display: none;"
                :disabled="uploading" />
        </div>

        <div v-else class="image-container">
            <img :src="block.src" :alt="'Image'" @click="triggerFileInput" />

            <div class="image-overlay">
                <v-btn icon small @click="triggerFileInput" color="white" variant="elevated">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon small @click="removeImage" color="white" variant="elevated">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </div>
            <input ref="fileInput" type="file" accept="image/*" @change="onFileSelected" style="display: none;" />
        </div>
        <!-- Affichage des erreurs -->
        <v-alert v-if="uploadError" type="error" dismissible @click:close="uploadError = null" class="mt-2">
            {{ uploadError }}
        </v-alert>

        <div class="mt-2">
            <div class="text-subtitle-2 text-sm ml-2">Largeur : {{ block.styles?.width }}</div>
            <v-slider :model-value="block.styles?.width" @update:model-value="updateWidth" min="10" max="100"
                hide-details></v-slider>

            <div class="mt-2 d-flex justify-center">

                <v-btn-toggle :model-value="block.styles?.alignment || 'center'" @update:model-value="updateAlignment">
                    <v-btn value="left" size="small" variant="outlined">
                        <v-icon>mdi-format-align-left</v-icon>
                        <v-tooltip activator="parent" location="top">Gauche</v-tooltip>
                    </v-btn>
                    <v-btn value="center" size="small" variant="outlined">
                        <v-icon>mdi-format-align-center</v-icon>
                        <v-tooltip activator="parent" location="top">Centre</v-tooltip>
                    </v-btn>
                    <v-btn value="right" size="small" variant="outlined">
                        <v-icon>mdi-format-align-right</v-icon>
                        <v-tooltip activator="parent" location="top">Droite</v-tooltip>
                    </v-btn>
                </v-btn-toggle>

            </div>
        </div>

    </div>
</template>

<script>
import AdminService from '@/services/admin.service.js'
import { useModuleStore } from '@/stores/moduleStore.js'
import { mapStores } from 'pinia'
export default {
    name: 'ImageBlock',
    props: {
        block: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            selectedFile: null,
            uploading: false,
            uploadError: null
        }
    },
    computed: {
        ...mapStores(useModuleStore),
        imageStyles() {
            return {
                width: this.block.styles?.width || '100%',
                height: this.block.styles?.height || 'auto',
                borderRadius: this.block.styles?.borderRadius || '0px',
                objectFit: this.block.styles?.objectFit || 'cover'
            }
        },

    },
    mounted() {
    },
    methods: {
        triggerFileInput() {
            if (!this.uploading) {
                this.$refs.fileInput.click()
            }
        },

        async onFileSelected(event) {
            const file = event.target.files[0]
            if (!file) return

            // Validation de la taille (max 5MB)
            if (file.size > 5 * 1024 * 1024) {
                this.uploadError = 'L\'image est trop volumineuse. Taille maximale : 5MB'
                return
            }

            // Validation du type
            if (!file.type.startsWith('image/')) {
                this.uploadError = 'Veuillez sélectionner un fichier image valide'
                return
            }

            this.uploading = true
            this.uploadError = null

            const id_event = this.moduleStore.evenement.id
            const result = await AdminService.uploadMailingSystemImage(file, id_event)


            if (result && result.url) {
                this.$emit('update', {
                    src: result.url,
                    alt: 'Image'
                })
            } else {
                this.uploadError = result?.error || 'Erreur lors de l\'upload de l\'image'
            }

        },

        removeImage() {
            this.$emit('update', {
                src: '',
                alt: ''
            })
        },

        updateStyles() {
            this.$emit('update', {
                styles: { ...this.block.styles }
            })
        },

        updateWidth(value) {
            const calculatedwidth = parseInt(value) + "%";
            this.$emit('update', {
                styles: { ...this.block.styles, width: calculatedwidth }
            })
        },

        updateAlignment(value) {
            this.$emit('update', {
                styles: { ...this.block.styles, alignment: value }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.image-block {
    position: relative;
    border: 1px solid transparent;
    border-radius: 4px;
    transition: all 0.2s;
}

.block-header {
    display: flex;
    justify-content: flex-end;
    padding: 4px 8px;
    background: #f5f5f5;
    border-radius: 4px 4px 0 0;
    opacity: 0;
    transition: opacity 0.2s;

    .image-block:hover & {
        opacity: 1;
    }
}

.properties-toolbar {
    background: #f8f9fa;
    padding: 12px;
    border-bottom: 1px solid #e0e0e0;

    .v-text-field,
    .v-select {
        margin-bottom: 0;
    }
}

.image-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;
    border: 2px dashed #ddd;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover:not(.uploading) {
        border-color: #2196f3;
        background: #f3f9ff;
    }

    &.uploading {
        cursor: not-allowed;
        border-color: #2196f3;
        background: #f3f9ff;
    }

    p {
        margin-top: 8px;
        color: #666;
        font-size: 14px;
    }
}

.image-container {
    position: relative;
    display: inline-block;
    width: 100%;

    img {
        display: block;
        border-radius: 4px;
        cursor: pointer;
        transition: opacity 0.2s;
        max-width: 100%;
    }

    &:hover img {
        opacity: 0.8;
    }
}

.image-overlay {
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    gap: 4px;
    opacity: 0;
    transition: opacity 0.2s;

    .image-container:hover & {
        opacity: 1;
    }
}
</style>
